module.exports = {
    "crude": {
        "search": "Поиск",
        "actions": "Действия",
        "nextPage": "Следующая страница",
        "lastPage": "Последняя страница",
        "back": "Назад",
        "empty": "пустой",
        "edit": "Редактировать",
        "delete": "Удалить",
        "save": "Сохранить",
        "success": "Сохранено успешно",
        "invalidDataFields": "следующие поля данных являются недействительными:  ",
        "create": "создать",
        "data": "данные",
        "view": "show",
        "cancel": "отменить",
        "noContent": "никаких записей",
        "resetFilter": "Сбрось фильтр, чтобы показать больше!",
        "createOwnTextField": "Создай собственное текстовое поле",
        "textFieldName": "Наклейка",
        "textFieldValue": "Значение",
        "insertTextFieldLabel": "Пожалуйста, вставьте имя",
        "deleteTextField": "удалить",
        "entries": "записи",
        "entry": "вход",
        "tabDetail": "Подробности",
        "entity": "Entity",
        "of": "с сайта",
        "uploadNewFile": "Загрузите новый файл",
        "upload": "загрузить",
        "uploadErrorExtension": "Ошибка при загрузке - неправильное расширение",
        "confirm": "Ок",
        "deleteFileQuestion": "Ты действительно хочешь удалить этот файл? Операция не может быть отменена.",
        "deleteFileQuestionTitle": "Внимание!",
        "deleteEntityQuestion": "Ты действительно хочешь удалить эту сущность? Операция не может быть отменена.",
        "deleteEntityeQuestionTitle": "Внимание!",
        "errorLargeFileUpload": "Слишком большой размер файлов.",
        "useCroppedImage": "Используй изображение",
        "useOriginalImage": "Используй происхождение",
        "available": "доступно",
        "searchColumn": "Поисковая колонка",
        "manageColumns": "Управление колоннами",
        "hideColumn": "Скрыть колонку",
        "pinToRight": "Штырь вправо",
        "pinToLeft": "Штырь влево",
        "sortAsc": "Сорт ASC",
        "sortDesc": "Сортировка DESC",
        "hideAll": "Скрыть все",
        "showAll": "Показать все",
        "preview": "Предварительный просмотр",
        "title": "Название",
        "description": "Описание",
        "tooltip": "Подсказка",
        "sort": "Сортировка",
        "settings": "Настройки",
        "incomingReference": "Ссылка",
        "language": "Язык",
        "deleteTabQuestionTitle": "Внимание!",
        "deleteTabQuestion": "Ты действительно хочешь удалить эту вкладку? Все настройки для этой вкладки будут сброшены!",
        "deleteElementQuestionTitle": "Внимание!",
        "deleteElementQuestion": "Ты действительно хочешь удалить этот элемент? Все настройки для этой колонки будут сброшены!",
        "configurationEditorDescriptionStringLayout": "В этой колонке можно выбрать три варианта для ввода текста:",
        "configurationEditorDescriptionEnumLayout": "Для выбора элементов в этой колонке можно выбрать два варианта:",
        "configurationEditorDescriptionBooleanLayout": "Для выбора элементов в этой колонке можно выбрать два варианта:",
        "configurationEditorDescriptionForeignEntityLayout": "Для выбора элементов в этой колонке можно выбрать два варианта:",
        "stringLayoutsingleline": "Однострочник",
        "stringLayoutmultiline": "Многолинейный",
        "stringLayouteditor": "RichTextEditor",
        "enumLayoutradio": "Радиокнопка",
        "enumLayoutdropdown": "Dropdown",
        "booleanLayoutcheckbox": "Чекбокс",
        "booleanLayoutswitch": "Переключатель",
        "foreignEntityLayoutpopUp": "PopUp",
        "foreignEntityLayoutautocomplete": "Dropdown",
        "foreignEntityLayoutlist": "Список",
        "formatTooltipbold": "Bold",
        "formatTooltipitalic": "Курсив",
        "formatTooltipunderline": "Подчеркни",
        "formatTooltipstrike": "Страйк",
        "formatTooltipclean": "Удалить формат",
        "formatTooltipcodeBlock": "Код",
        "formatTooltipblockquote": "Blockquote",
        "formatTooltipcolor": "Цвет",
        "formatTooltipbackground": "Фон",
        "formatTooltipfont": "Шрифт",
        "formatTooltipalign": "Выровняй",
        "formatTooltipheader": "Fontsize",
        "formatTooltipsuper": "Superscript",
        "formatTooltipsub": "Subscript",
        "formatTooltipordered": "Упорядоченный список",
        "formatTooltipbullet": "Пули",
        "true": "true",
        "false": "false",
        "selectEntity": "Выберите организацию",
        "filter": "Фильтр",
        "useFilter": "Используй фильтр",
        "defaultFilter": "Сбросить фильтр",
        "expand": "Развернуть",
        "hide": "Скрыть",
        "minimumSelectionError": "Должно быть выбрано не менее {{min}} записей.",
        "maximumSelectionError": "Можно выбрать максимум {{max}} записей."
    }
}
;